import CurrencyFormatter from '../../components/Grid/CurrencyFormatter';
import NumberFormatter from '../../components/Grid/NumberFormatter';
import Summary from '../../components/Grid/Summary';
import CurrencySummary from '../../components/Grid/CurrencySummary';
import { DateFormatter } from '../../components/Grid/formatters/DateFormater';

export default [
  {
    key: 'invoice',
    name: 'NF',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    width: 50,
  },
  {
    key: 'salesOrder',
    name: 'Ped',
    type: 'number',
    resizable: true,
    filterable: true,
    sortable: true,
    width: 50,
  },
  {
    key: 'billingDate',
    name: 'DT',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    width: 70,
    formatter: DateFormatter
  },
  {
    key: 'customerName',
    name: 'Cliente',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    // width: 120,
  },
  {
    key: 'customerRegister',
    name: 'CNPJ',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    width: 110,
  },
  {
    key: 'cityName',
    name: 'Cidade',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    // width: 100,
  },
  {
    key: 'stateCode',
    name: 'UF',
    type: 'text',
    resizable: true,
    filterable: true,
    sortable: true,
    width: 50,
  },
  {
    key: 'revenues',
    name: 'Qtde',
    type: 'number',
    formatter_index: 1,
    resizable: true,
    sortable: true,
    summary: Summary,
    width: 70,
    formatter: NumberFormatter,
  },
  {
    key: 'revenuesValue',
    name: 'Valor Total',
    type: 'number',
    resizable: true,
    sortable: true,
    width: 100,
    summary: CurrencySummary,
    formatter: CurrencyFormatter,
  }
];
